/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChangeLogDescription } from './changeLogDescription';
import { UsersChanges } from './usersChanges';


export interface TeamChangeLog { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    actionPerformed: string;
    teamId: string;
    usersChanges?: UsersChanges;
    description?: ChangeLogDescription;
    projectId?: string;
}

